export default "__VITE_ASSET__C55_ImsR__"